import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
export var checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var resourceId = action.taskType.resourceId;
    var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
    var anyBuildingWithProductionInProgress = availableBuildings.some(utilBuildings.isProducing);
    return anyBuildingWithProductionInProgress ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable.ts
// module id = 2358
// module chunks = 3